import styled from 'styled-components';

export const HcpProfileDescriptionSectionUL = styled.ul`
  margin-top: 0;
`;
